import { Anchor as MantineAnchor } from '@mantine/core'

import type { AnchorProps } from '@/components/Anchor/Anchor.types'

import classes from './Anchor.module.css'

export function Anchor({ variant = 'primary', ...props }: AnchorProps) {
  return <MantineAnchor className={classes[variant]} {...props} />
}
